import React, { Component, PropTypes } from 'react';
import DateDropdown from '../common/components/DateDropdown';
import moment from 'moment';
import { dateFormats } from '../util/constants';
import { getEndOfDayTimestamp, isValidFromDate, isValidToDate } from '../util/Etc';

const TODAY = moment().format(dateFormats.ISO_8601);
const END_OF_TODAY = moment(getEndOfDayTimestamp(TODAY)).format(dateFormats.ISO_8601);
const MAX = 'max';
const MIN = 'min';

export default class DateRangeSelector extends Component {
  static contextTypes = {
    onWarning: PropTypes.func.isRequired
  };

  static propTypes = {
    className: PropTypes.string,
    dateSelectorClassName: PropTypes.string,
    maxOption: PropTypes.string,
    maxValue: PropTypes.string,
    minOption: PropTypes.string,
    minValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    dateSelectorClassName: '',
    maxOption: END_OF_TODAY,
    maxValue: null,
    minOption: TODAY,
    minValue: null,
  };

  handleDateChange(date, selector) {
    const { maxValue, minValue, onChange } = this.props;

    if (selector === MIN) {
      const min = date;
      if (isValidFromDate(min, maxValue)) {
        onChange({ min, max: maxValue });
      } else {
        onChange({ min, max: null });
        this.context.onWarning('Make sure your "From Date" is before your "To Date".');
      }
    } else {
      const max = date ? moment(getEndOfDayTimestamp(date)).format(dateFormats.ISO_8601) : null;
      if (isValidToDate(date, minValue)) {
        onChange({ min: minValue, max });
      } else {
        onChange({ min: null, max });
        this.context.onWarning('Make sure your "To Date" is after your "From Date".');
      }
    }
  }

  render() {
    const {
      className,
      dateSelectorClassName,
      maxValue,
      minValue,
      maxOption,
      minOption
    } = this.props;

    return (
      <div className={className}>
        <DateDropdown
          className={`min-width-100 ${dateSelectorClassName}`}
          clearable={false}
          maxDate={maxOption}
          minDate={minOption}
          onChange={(date) => this.handleDateChange(date, MIN)}
          value={minValue}
        />
        <DateDropdown
          className={`min-width-100 mg-left-sm ${dateSelectorClassName}`}
          clearable={false}
          maxDate={maxOption}
          minDate={minOption}
          onChange={(date) => this.handleDateChange(date, MAX)}
          value={maxValue}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/DateRangeSelector.jsx